import { Grid, Typography } from '@mui/material'
import { GridSize } from '@mui/material/Grid/Grid'
import { ContextMenu } from 'Components/Cards/Molecules'
import { ITeacher } from 'Entities/teacher'
import moment from 'moment'
import { CardWrapper } from '../Atoms'

type Props = {
  user: ITeacher
  onEdit: (id: number) => void
  onRemove: (id: number) => void
  gridSize?: boolean | GridSize
}

export const TeacherCard = ({ user, gridSize, ...props }: Props) => {
  const contextProps = { id: user.id, ...props }
  return (
    <CardWrapper>
      <Grid container flexWrap='nowrap' columnSpacing={2} alignItems='center'>
        <Grid item xs={gridSize}>
          <Typography variant='body1'>{`${user.firstName || ''} ${user.lastName || ''}`}</Typography>
        </Grid>
        <Grid item xs={gridSize}>
          <Typography variant='body1'>{user.login}</Typography>
        </Grid>
        <Grid item xs={gridSize}>
          <Typography variant='body1'>{user.email}</Typography>
        </Grid>
        <Grid item xs={gridSize}>
          <Typography variant='body1'>{user.createdDate ? moment(user.createdDate).format('YYYY-MM-DD hh:mm') : ''}</Typography>
        </Grid>
        <Grid item flexGrow={1} display='flex' justifyContent='flex-end'>
          <ContextMenu {...contextProps} />
        </Grid>
      </Grid>
    </CardWrapper>
  )
}
